import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface SiteService {
    id: number;
    title: string;
    description: string;
    iconKey: string;
    ctaText?: string;
    ctaUrl?: string;
    sort: number;
}
export interface Product {
    id: number;
    name: string;
    groupId: number;
    groupName: string;
    img: string;
}
export interface HomeHero {
    eyebrow: string;
    title: string;
    description: string;
    primaryText: string;
    primaryUrl: string;
    secondaryText: string;
    secondaryUrl: string;
}

export interface HomeMetric {
    value: string;
    label: string;
}

export interface HomeSimpleItem {
    title: string;
    description: string;
}

export interface HomeIndustry {
    no: string;
    title: string;
    description: string;
}

export interface HomeCase {
    tag: string;
    title: string;
    description: string;
}

export interface HomeProcess {
    no: string;
    title: string;
    description: string;
}

export interface HomeData {
    hero: HomeHero;
    metrics: HomeMetric[];
    trustItems: HomeSimpleItem[];
    services: SiteService[];
    industries: HomeIndustry[];
    badges: HomeSimpleItem[];
    cases: HomeCase[];
    process: HomeProcess[];
    features: HomeSimpleItem[];
}
export interface Certificate {
    id: number;
    title: string;
    category: string;
    description: string;
    fileName: string;
    filePath: string;
    year: string;
    sort: number;
}


export interface AboutHero {
    eyebrow: string;
    title: string;
    description: string;
}

export interface AboutProfile {
    kicker: string;
    title: string;
    description: string;
}

export interface AboutFeature {
    title: string;
    description: string;
}

export interface AboutTimeline {
    year: string;
    tag: string;
    title: string;
    description: string;
}

export interface AboutData {
    hero: AboutHero;
    profile: AboutProfile;
    features: AboutFeature[];
    timeline: AboutTimeline[];
}
export interface Office {
    id: number;
    country: string;
    description: string;
    tag: string;
    sort: number;
}

export interface ContactRequest {
    fullName: string;
    company: string;
    email: string;
    phone: string;
    serviceCategory: string;
    priority: string;
    message: string;
}

export interface SocialLink {
    id: number;
    name: string;
    iconKey: string;
    url: string;
    sort: number;
}
@Injectable({
    providedIn: 'root'
})
export class SiteApiService {

    private apiUrl = '/api';

    constructor(private http: HttpClient) { }

    getServices(): Observable<SiteService[]> {
        return this.http.get<SiteService[]>(this.apiUrl + '/site/services');
    }

    getHome(): Observable<HomeData> {
        return this.http.get<HomeData>(this.apiUrl + '/site/home');
    }

    getCertificates(): Observable<Certificate[]> {
        return this.http.get<Certificate[]>(this.apiUrl + '/site/certificates');
    }

    getFileUrl(path: string): string {
        if (!path) {
            return '#';
        }

        if (path.indexOf('http') === 0) {
            return path;
        }

        return this.apiUrl.replace('/api', '') + path;
    }
    getAbout(): Observable<AboutData> {
        return this.http.get<AboutData>(this.apiUrl + '/site/about');
    }
    getOffices(): Observable<Office[]> {
        return this.http.get<Office[]>(this.apiUrl + '/site/offices');
    }

    sendContactRequest(data: ContactRequest): Observable<any> {
        return this.http.post(this.apiUrl + '/site/contact-request', data);
    }

    getProducts(): Observable<Product[]> {
        return this.http.get<Product[]>('https://istoreapi.iosc.az/api/getItemList');
    }
    getSocialLinks(): Observable<SocialLink[]> {
        return this.http.get<SocialLink[]>(this.apiUrl + '/site/social-links');
    }
    getImageUrl(path: string): string {
        if (!path) {
            return 'assets/img/products/placeholder.png';
        }

        if (path.indexOf('http') === 0) {
            return path;
        }

        if (path.indexOf('/assets/') === 0) {
            return path.substring(1);
        }

        return this.apiUrl.replace('/api', '') + path;
    }


}